var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Menu",

    getDefaultProps () {
        return {"width":"25px","height":"23px","viewBox":"0 0 25 23","version":"1.1","xmlns":"http://www.w3.org/2000/svg","data-svgreactloader":"[[\"http://www.w3.org/2000/svg\",\"xlink\",\"http://www.w3.org/1999/xlink\"]]"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <title>E777B67B-EF3D-47B8-8546-23013D048AB5</title>
  <desc>Created with sketchtool.</desc>
  <defs/>
  <g id="Main" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <g id="landing_mobile-1-hamburger" transform="translate(-325.000000, -25.000000)" fill="#444444">
      <g id="Group-4" transform="translate(325.000000, 25.000000)">
        <rect id="Rectangle-17" x="0" y="0" width="25" height="3"/>
        <rect id="Rectangle-17-Copy" x="0" y="10" width="25" height="3"/>
        <rect id="Rectangle-17-Copy-2" x="0" y="20" width="25" height="3"/>
      </g>
    </g>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/images/icons/menu.svg